import { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export const getSelectedTabBackground = (theme: Theme) =>
  theme.palette.mode === 'dark' ? '#1D4ED8' : '#041121';

export const getSelectedTabBorder = (theme: Theme) =>
  theme.palette.mode === 'dark' ? '#1A3A5A' : '#041121';

export const getSelectedTabHoverBackground = (theme: Theme) =>
  theme.palette.mode === 'dark' ? '#CCCCCC' : '#0a1f3d';

export const getNavigationContainedButtonStyles = (theme: Theme) => ({
  color: '#FFFFFF',
  backgroundColor: getSelectedTabBackground(theme),
  border: '1px solid',
  borderColor: getSelectedTabBorder(theme),
  boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
  '&:hover': {
    backgroundColor: getSelectedTabHoverBackground(theme),
    borderColor: getSelectedTabBorder(theme),
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  '&.Mui-disabled': {
    color: alpha('#FFFFFF', 0.6),
    backgroundColor: alpha(getSelectedTabBackground(theme), 0.45),
    borderColor: alpha(getSelectedTabBorder(theme), 0.4),
  },
});

export const getNavigationOutlinedButtonStyles = (theme: Theme) => ({
  color: getSelectedTabBackground(theme),
  borderColor: alpha(getSelectedTabBackground(theme), 0.5),
  backgroundColor: alpha(getSelectedTabBackground(theme), theme.palette.mode === 'dark' ? 0.14 : 0.04),
  '& .MuiButton-startIcon': {
    color: 'inherit',
  },
  '&:hover': {
    borderColor: getSelectedTabBorder(theme),
    backgroundColor: alpha(getSelectedTabBackground(theme), theme.palette.mode === 'dark' ? 0.24 : 0.08),
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    borderColor: theme.palette.action.disabledBackground,
    backgroundColor: 'transparent',
  },
});
